export const BASE_URL = 'https://disease.sh/v3';
